import { createFileRoute } from "@tanstack/react-router";
import SelfFrontCosmetics from "@/features/assessments/pages/self-front-cosmetics/SelfFrontCosmetics";

export const Route = createFileRoute("/$locale/$partner/_cosmetic/self-front-cosmetics")({
	component: SelfFrontCosmetics,
});
